<template>
  <v-form>
    <v-layout justify-center pt-2>
      <v-flex pt-2>
        <v-container class="formWidth">
          <v-card ma-4>
            <v-layout column pa-4>
              <v-layout row>
                <image-input
                  :label="$t('accountCreation.accountLogo')"
                  :default="image"
                  :showImageInfos="false"
                  @change-image-input="onImageChange"
                  @error="onImageError"
                />
                <v-flex layout column pl-4 pt-4>
                  <v-text-field
                    v-model="account.name.fr"
                    :label="$t('accountCreation.accountName') + ' *'"
                    type="text"
                    required
                    @blur="updateSiteName()"
                  ></v-text-field>
                  <v-textarea
                    v-model="account.address"
                    @blur="updateAddress()"
                    :label="$t('accountCreation.accountAddress')"
                  ></v-textarea>
                </v-flex>
              </v-layout>

              <v-layout column>
                <v-flex xs12 pb-4>
                  <v-layout row wrap align-center justify-center>
                    <v-flex xs6 pr-4>
                      <v-text-field
                        v-model="userInfo.lastname"
                        @blur="updateLastName()"
                        :label="$t('accountCreation.lastname')"
                        :disabled="
                          typeof currentUser.loggedAsUser !== 'undefined' &&
                          currentUser.loggedAsUser !== null
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="userInfo.firstname"
                        @blur="updateFirstName()"
                        :label="$t('accountCreation.firstname')"
                        :disabled="
                          typeof currentUser.loggedAsUser !== 'undefined' &&
                          currentUser.loggedAsUser !== null
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap align-center justify-center>
                    <v-flex xs6 pr-4>
                      <v-text-field
                        v-model="userInfo.phone"
                        :label="$t('accountCreation.phone')"
                        :disabled="
                          typeof currentUser.loggedAsUser !== 'undefined' &&
                          currentUser.loggedAsUser !== null
                        "
                        @blur="updatePhone()"
                        maxlength="15"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="userInfo.email"
                        :rules="rules.user.emailRules"
                        :label="$t('accountCreation.email') + ' *'"
                        :disabled="
                          typeof currentUser.loggedAsUser !== 'undefined' &&
                          currentUser.loggedAsUser !== null
                        "
                        @blur="updateEmail()"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout column>
                <v-flex xs12 pb-4>
                  <v-layout
                    style="margin-top: 10%"
                    row
                    wrap
                    align-center
                    justify-center
                  >
                    <v-flex xs6 pr-4>
                      <v-icon color="primary" medium>mdi-instagram</v-icon>
                      <v-text-field
                        v-model="socials.instagram"
                        :label="$t('accountCreation.instagram')"
                        :placeholder="
                          $t('accountCreation.instagramPlaceholder')
                        "
                        :rules="rules['socials']"
                        @blur="updateSocials('instagram')"
                        maxlength="20"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-icon color="primary" medium>mdi-facebook</v-icon>
                      <v-text-field
                        v-model="socials.facebook"
                        @blur="updateSocials('facebook')"
                        :label="$t('accountCreation.facebook')"
                        :placeholder="$t('accountCreation.facebookPlaceholder')"
                        :rules="rules['socials']"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap align-center justify-center>
                    <v-flex xs6 pr-4>
                      <v-icon color="primary" medium>mdi-linkedin</v-icon>
                      <v-text-field
                        v-model="socials.linkedIn"
                        @blur="updateSocials('linkedIn')"
                        :label="$t('accountCreation.linkedIn')"
                        :placeholder="$t('accountCreation.linkedInPlaceholder')"
                        :rules="rules['socials']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-icon color="primary" medium>mdi-twitter</v-icon>
                      <v-text-field
                        v-model="socials.twitter"
                        :label="$t('accountCreation.twitter')"
                        :placeholder="$t('accountCreation.twitterPlaceholder')"
                        :rules="rules['socials']"
                        @blur="updateSocials('twitter')"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-alert type="error" :value="errorMessage" outline>{{
                translatedError
              }}</v-alert>
            </v-layout>
          </v-card>
          <v-flex layout align-center justify-end pt-2>
            <v-btn color="primary" class="text-none" @click="goBack()">
              {{ $t('accountCreation.return') }}
            </v-btn>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import ImageInput from './ImageInput';

export default {
  name: 'AccountInfoForm',
  components: { ImageInput },
  data() {
    return {
      errorMessage: '',
      image: { url: '', author: '', legend: { fr: '', en: '' } },
      imageError: null,
      userInfo: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
      },
      account: {
        structure: '',
        name: { fr: '', en: '' },
        address: '',
        logo: '',
      },
      socials: {
        linkedIn: '',
        facebook: '',
        twitter: '',
        instagram: '',
      },
      rules: {
        user: {
          emailRules: [
            (email) =>
              Boolean(email) || this.$t('accountCreation.errors.emailRequired'),
            (email) =>
              /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
                email
              ) || this.$t('accountCreation.errors.emailInvalid'),
          ],
        },
        socials: [
          (v) => !/[ ]/.test(v) || this.$t('accountCreation.errors.nospace'),
        ],
      },
    };
  },
  created() {
    this.userInfo.firstname = this.currentUser.content.firstname;
    this.userInfo.lastname = this.currentUser.content.lastname;
    this.userInfo.email = this.currentUser.username;
    this.userInfo.phone = this.currentUser.content.phone;
    //this.userInfo.password = this.currentUser.password;

    this.account.address = this.currentAccount.address;
    this.account.name.fr = this.currentAccount.name.fr;
    this.account.name.en = this.currentAccount.name.en;
    if (this.currentAccount.socials) {
      this.socials = JSON.parse(JSON.stringify(this.currentAccount.socials));
    }

    this.image.url = this.currentAccount.logoUrl;
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    currentAccountId() {
      return this.$store.getters['accounts/currentAccountId'];
    },
    translatedError() {
      if (this.errorMessage.match(/wrong.*username.*password/)) {
        return this.$t('login.errors.badCredentials');
      }
      if (this.errorMessage.match(/Login.*already/)) {
        return this.$t('login.errors.emailAlreadyUsed');
      }
      return this.$t('login.errors.generic');
    },
  },
  methods: {
    emailRules(email) {
      return [
        Boolean(email),
        /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
          email
        ),
      ];
    },
    updateFirstName() {
      if (this.userInfo.firstname !== this.currentUser.content.firstname) {
        let userPayload = { firstname: this.userInfo.firstname };
        this.updateUserInfos(userPayload);
      }
    },
    updateLastName() {
      if (this.userInfo.lastname !== this.currentUser.content.lastname) {
        let userPayload = { lastname: this.userInfo.lastname };
        this.updateUserInfos(userPayload);
      }
    },
    updatePhone() {
      if (this.userInfo.phone !== this.currentUser.content.phone) {
        let userPayload = { phone: this.userInfo.phone };
        this.updateUserInfos(userPayload);
      }
    },
    updateEmail() {
      console.log(
        'in update email',
        this.emailRules(this.userInfo.email),
        this.emailRules(this.userInfo.email).some((e) => !e)
      );
      if (
        this.emailRules(this.userInfo.email).some((e) => !e) ||
        this.userInfo.email === this.currentUser.username
      ) {
        return;
      }
      let credentialsPayload = { username: this.userInfo.email };
      this.updateUserCredentials(credentialsPayload);
    },
    async updateUserInfos(userPayload) {
      try {
        this.$store.commit('app/SET_LOADING');
        await this.$store.dispatch('auth/UPDATE_USER', {
          userPayload: userPayload,
          kuzzle: this.$kuzzle,
        });
      } catch (error) {
        console.error(error.message);
        this.errorMessage = error.message;
      }
      this.$store.commit('app/UNSET_LOADING');
    },
    updateSiteName() {
      if (this.account.name !== this.currentAccount.name) {
        let accountPayload = { name: this.account.name };
        this.updateAccountInfos(accountPayload);
      }
    },
    updateAddress() {
      if (this.account.address !== this.currentAccount.address) {
        let accountPayload = { address: this.account.address };
        this.updateAccountInfos(accountPayload);
      }
    },
    updateSocials(socialName) {
      if (/[ ]/.test(this.socials[socialName])) {
        return;
      }
      if (
        (!this.currentAccount.socials && this.socials[socialName] !== '') ||
        (this.currentAccount.socials &&
          this.socials[socialName] !== this.currentAccount.socials[socialName])
      ) {
        let accountPayload = {
          socials: { [socialName]: this.socials[socialName] },
        };
        this.updateAccountInfos(accountPayload);
      }
    },

    async updateAccountInfos(accountPayload) {
      try {
        this.$store.commit('app/SET_LOADING');
        await this.$store.dispatch('accounts/UPDATE_ACCOUNT', {
          accountPayload: accountPayload,
          index: this.$store.getters['auth/currentUserIndex'],
          accountId: this.currentAccountId,
          kuzzle: this.$kuzzle,
        });
      } catch (error) {
        console.error(error.message);
        this.errorMessage = error.message;
      }
      this.$store.commit('app/UNSET_LOADING');
    },
    async updateUserCredentials(payload) {
      try {
        this.$store.commit('app/SET_LOADING');
        await this.$store.dispatch('auth/UPDATE_USER_CREDENTIALS', {
          userPayload: payload,
          kuzzle: this.$kuzzle,
        });
        let userPayload = { email: this.userInfo.email };
        this.updateUserInfos(userPayload);
        this.$store.commit('app/UNSET_LOADING');
      } catch (error) {
        console.error('error:', error.message);
        this.errorMessage = error.message;
        this.userInfo.email = this.currentUser.username;
      }
    },
    onImageChange(image) {
      if (this.image !== image) {
        this.image = image;
        let accountPayload = { logoUrl: this.image.url };
        this.updateAccountInfos(accountPayload);
      }
    },
    onImageError(error) {
      this.imageError = error.message;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="sass">

.formWidth
  width: 800px
</style>
